import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import lock_svg from '../../../pages/admin/admin_assets/img/Lock.svg';
import mail_svg from '../../../pages/admin/admin_assets/img/mail.svg';
import config from '../../../config/config.js';

const LoginForm = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);  // Add loading state
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const trimmedEmail = email.trim();  // Trim email before sending
        const trimmedPassword = password.trim();  // Trim password as well
        
        setLoading(true);  // Set loading to true before making request

        try {
            const response = await axios.post(`${config.API_BASE_URL}/login.php`,
                JSON.stringify({
                    email: trimmedEmail,
                    password: trimmedPassword
                }), 
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true  // Ensure credentials (cookies, sessions) are included
                }
            );
            
    
            if (response.data.success) {
                // Store user info in localStorage for session management
                localStorage.setItem('user', JSON.stringify(response.data.user));

                // Optionally, call the onLogin function if you want to update the parent component
                onLogin(response.data.user);

                // Navigate to the overview page
                navigate('/admin/overview');
            } else {
                setErrorMessage('Invalid email or password.');
            }
        } catch (error) {
            setErrorMessage('Something went wrong. Please try again later.');
            console.error('Login error:', error);
        } finally {
            setLoading(false);  // Set loading to false after the request is completed
        }
    };

    return (
        <div className="login-form-content">
            <h1 className="login-heading black_txt">Log In to Brew Your Brand</h1>
            <p className="login-text black_txt">Enter your login details to access your account.</p>
            <form onSubmit={handleSubmit}>
                <div className="form-group email-group">
                    <img src={mail_svg} className="email_icon" alt="Email Icon" />
                    <label htmlFor="email">Email Address</label>
                    <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required 
                    />
                </div>
                <div className="form-group password-group">
                    <img src={lock_svg} className="lock_icon" alt="Lock Icon" />
                    <label htmlFor="password">Password</label>
                    <div className="password-wrapper">
                        <input 
                            type={showPassword ? "text" : "password"} 
                            id="password" 
                            name="password" 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required 
                        />
                        <span className="toggle-password" onClick={togglePasswordVisibility}>
                            <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                        </span>
                    </div>
                </div>
                <button type="submit" className="login-button" disabled={loading}>
                    {loading ? 'Logging In...' : 'Login'}
                </button>
            </form>

            {errorMessage && (
                <div className="error_msg text-left">
                    <h6>Email or password error</h6>
                    <p>{errorMessage}</p>
                    <p>Please retry or contact support if you need help accessing your account.</p>
                </div>
            )}

            <hr className="loginhr" />
            <div className="forgot-password-link">
                <a href="/admin/forgot-password">Forgot Password?</a>
            </div>
        </div>
    );
};

export default LoginForm;
